import "./History.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import Paginate from "../Atomics/Paginate/Paginate";
import ThinFooter from "../Footer/ThinFooter";
import WatchedVideos from "./WatchedVideos";
import { useEffect, useState } from "react";
import { historyFetcher } from "../../api/requests";
import { paginate } from "../../api/requests";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const History = () => {
  const [histories, setHistories] = useState();
  const [paginationInfo, setPaginationInfo] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const cookieUser = Cookies.get("vaghfnamaUser");
    if (!cookieUser) {
      history.push("/auth/login");
      return;
    }

    const fetchHistories = async () => {
      try {
        const res = await historyFetcher.get();
        setHistories(res);
        setPaginationInfo(res);
        setTotalCount(res.count);
      } catch (error) {
        console.error("Failed to fetch history:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHistories();
  }, [history]);

  const handlePageChange = async (arg) => {
    setIsLoading(true);

    try {
      let res;

      if (typeof arg === "string") {
        const startIndex = arg.indexOf("api") + 3;
        res = await paginate.get(arg.slice(startIndex));
      } else if (typeof arg === "object" && arg.baseUrl && arg.page) {
        res = await paginate.getByNumber(arg.baseUrl, arg.page);
      } else {
        res = arg;
      }

      setHistories(res);
      setPaginationInfo(res);
      setTotalCount(res.count);
    } catch (error) {
      console.error("Error fetching page:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ContentWrapper>
      <Container fluid style={{ minHeight: "calc(100vh - 123px)" }}>
        <div style={{ display: "flex" }}>
          <div
            className="video-block section-padding"
            style={{
              paddingLeft: "40px",
              paddingRight: "40px",
            }}
          >
            <Row>
              {isLoading ? (
                <div
                  className="d-flex justify-content-center mb-5"
                  style={{ width: "100%" }}
                >
                  <Spinner animation="border" role="status"></Spinner>
                </div>
              ) : histories?.count > 0 ? (
                <>
                  <Col md={12}>
                    <SectionHeader heading="تاریخچه مشاهدات" />
                  </Col>
                  <WatchedVideos videos={histories?.results} />
                </>
              ) : (
                <p className="mr-3">ویدئوای وجود ندارد.</p>
              )}
            </Row>
            <Paginate
              count={totalCount}
              value={paginationInfo}
              onPageChange={handlePageChange}
              limit={12}
            />
          </div>
        </div>
      </Container>
      <ThinFooter />
    </ContentWrapper>
  );
};

export default History;
